.page {
  background: #fff;
}

.hero {
  position: relative;
  /* Fluid: short on phones, generous on desktop. Caps at 480px so a
     16:9 monitor doesn't fill its viewport with hero. */
  min-height: clamp(220px, 45vh, 480px);
  display: grid;
  place-items: center;
  overflow: hidden;
}

.hero img {
  position: absolute;
  width: 100%;
  height: 100%;
  object-fit: cover;
  filter: saturate(0.9) contrast(1.1);
}

.overlay {
  position: absolute;
  inset: 0;
  background: transparent;
}

.content {
  position: relative;
  z-index: 1;
  color: #fff;
  text-align: center;
  max-width: 640px;
  padding: var(--space-7) var(--space-6);
}

/* Translucent backdrop chip — used when the underlying banner is light
   and white type would otherwise wash out. Scales with content: rounded
   pill on small screens, wider rounded plate when the title + button
   stack out. Backdrop-filter softens whatever lives below. */
.contentChip {
  background: rgba(20, 18, 16, 0.18);
  border-radius: clamp(14px, 3vw, 22px);
  backdrop-filter: blur(2px);
  -webkit-backdrop-filter: blur(2px);
  box-shadow: 0 4px 14px rgba(0, 0, 0, 0.08);
  padding: clamp(20px, 4vw, 40px) clamp(20px, 5vw, 56px);
  margin: clamp(20px, 5vw, 48px);
  max-width: min(640px, 90vw);
}

.content h1 {
  margin: 0 0 var(--space-3);
  font-family: var(--font-display);
  font-size: clamp(2.2rem, 4vw, 3.3rem);
  letter-spacing: 0.2em;
  text-transform: uppercase;
}

.content p {
  margin: 0 0 var(--space-5);
  color: rgba(255, 255, 255, 0.95);
  font-size: clamp(1rem, 1.4vw, 1.2rem);
  font-weight: 700;
  line-height: 1.45;
  letter-spacing: 0.01em;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.35);
  max-width: 44ch;
  margin-left: auto;
  margin-right: auto;
}
